import React from "react";
import "../../styles/Home-page-component/testimonials.css";

const TestimonialsSection = () => {
  return (
    <section className="testimonials-section">

      <div className="container">
        <h2 className="section-title">
          What Our Clients Say
        </h2>
      </div>

      {/* CAROUSEL */}
      <div className="carousel">

        <div className="carousel-track">

          {/* ORIGINAL */}
          {[...Array(2)].map((_, i) => (
            <React.Fragment key={i}>

              <div className="testimonial-card">
                <p>"Incogniflex transformed our infrastructure completely."</p>
                <strong>Jennifer Martinez</strong>
                <span>CTO, Fortune 500 Company</span>
              </div>

              <div className="testimonial-card">
                <p>"Delivered ahead of schedule and exceeded expectations."</p>
                <strong>Robert Chen</strong>
                <span>VP Engineering</span>
              </div>

              <div className="testimonial-card">
                <p>"Increased our efficiency by 40%."</p>
                <strong>Sarah Thompson</strong>
                <span>Operations Director</span>
              </div>

              <div className="testimonial-card">
                <p>"Their AI solutions gave us a massive competitive advantage."</p>
                <strong>David Lee</strong>
                <span>Head of Innovation</span>
              </div>

            </React.Fragment>
          ))}

        </div>

      </div>

    </section>
  );
};

export default TestimonialsSection;